// Filename: bumble_cfg.js
// Timestamp: 2018.12.09-18:14:35 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

// import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'
import ptrec from '@bumblehead/gani/src/parts/ptrec.js'
import ptrecls from '@bumblehead/gani/src/parts/ptrecls.js'
import uianchored from '@bumblehead/gani/src/parts/uianchored.js'
import uilink from '@bumblehead/gani/src/parts/uilink.js'
import uiinline from '@bumblehead/gani/src/parts/uiinline.js'
import uistatic from '@bumblehead/gani/src/parts/uistatic.js'
import uiroot from '@bumblehead/gani/src/parts/uiroot.js'
import uiimg from '@bumblehead/gani/src/parts/uiimg.js'
import uiobjls from '@bumblehead/gani/src/parts/uiobjls.js'
import uils from '@bumblehead/gani/src/parts/uils.js'
import uidropdown from '@bumblehead/gani/src/parts/uidropdown.js'
import uiblock from '@bumblehead/gani/src/parts/uiblock.js'
// import uilsparts from '@bumblehead/gani/src/parts/uilsparts.js'

import datascene from './datascene.js'

import uipageselect from './uipageselect.js'
import uiarticle from './uiarticle.js'
import uiarticleTileOneLine from './uiarticleTileOneLine.js'
import uiarticleTileSuggest from './uiarticleTileSuggest.js'

import uiarticleprev from './uiarticleprev.js'
import uisitemap from './uisitemap.js'
import uisitemaptags from './uisitemaptags.js'
import uicanvasportal from './uicanvasportal.js'
import uicanvasportalbg from './uicanvasportalbg.js'

import uicanvasstageseq from './uicanvasstageseq.js'
import uicanvasstageseqaction from './uicanvasstageseqaction.js'
import uicanvasstageseqactionshape from './uicanvasstageseqactionshape.js'

import * as querieslogic from '@bumblehead/gaql/src/queries/logic.js'
import * as queriestime from '@bumblehead/gaql/src/queries/time.js'
import * as queriescore from '@bumblehead/gaql/src/queries/core.js'
import * as queriesaggregate from '@bumblehead/gaql/src/queries/aggregate.js'
import * as queriestransform from '@bumblehead/gaql/src/queries/transform.js'
import * as queriesclient from '@bumblehead/gani/src/queries/client.js'
import * as queriesstring from '@bumblehead/gaql/src/queries/string.js'
import * as queriesbumble from './bumble_queries.js'

import gaqlrun from '@bumblehead/gaql/src/gaqlrun.js'

export default {
  gaqlrun,
  gaqlqueries: [
    queriescore,
    queriestime,
    querieslogic,
    queriesaggregate,
    queriestransform,
    queriesclient,
    queriesstring,
    queriesbumble
  ],

  nodes: [
    ptrec,
    ptrecls,

    uilink,
    uianchored,
    uiinline,
    uistatic,
    uiroot,
    uiimg,
    uiobjls,
    uils,
    uidropdown,
    uiblock,
    // uilsparts,

    datascene,

    uipageselect,
    uiarticleprev,
    uisitemap,
    uisitemaptags,
    uiarticle,
    uiarticleTileOneLine,
    uiarticleTileSuggest,

    uicanvasportal,
    uicanvasportalbg,

    uicanvasstageseq,
    uicanvasstageseqaction,
    uicanvasstageseqactionshape
  ]
}
